

export default function FormInput (props) {

  let inputDivStyle ={
    // display: 'flex',
    position: 'relative',
    margin: '10px 0 20px 0',
  }

  let inputStyle = {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '500',
    textAlign: 'left',
    margin: '4px 0 4px 0px',
    padding: '5px',
    border: 'none',
    background: '#FFF',
    borderRadius: '7px',
    width: '440px'
  }

  let labelStyle = {
    margin: 'auto 30px auto 0',
    padding: '0 0 0 0px',
    textAlign: 'left',
    fontWeight: '600',
    width: '440px',
  }

  let rowStyle = {
    display: 'flex',
  }

  return (
    <div style={inputDivStyle}>
      <p style={labelStyle}>{props.label}</p>
      <div style={rowStyle}>
        <div>
          </div>
          <input style = {inputStyle}
            value={props.value}
            onChange={e => props.setHook(e.target.value)}
            type={`${props.type}`}
            onWheel={(e) => e.target.blur()}
          />
        </div>
        <hr
          style={{
            width: '450px',
            margin: '0 0 10px 10px'
          }}/>
    </div>
  )
}
